/*
 * @Author: DYM
 * @Date: 2021-03-03 15:38:15
 * @LastEditors: zxf
 * @LastEditTime: 2023-07-04 10:19:20
 * @Description: file content
 */
import Vue from 'vue';
import ChartComponents from './chart/index';

import ReProgress from './reProgress.vue';
import ViewImgDialog from './ViewImgDialog.vue';
import ViewVideoDialog from './ViewVideoDialog.vue';
import DeptTree from './DeptTree/DeptTree.vue';
import SyncDeptTree from './DeptTree/SyncDeptTree.vue';
import AsyncDeptTree from './DeptTree/AsyncDeptTree.vue';
import KTable from './KTable/KTable.vue';
import KTableInfinite from './KTable/KTableInfinite.vue';
import ImportUpload from './ImportUpload/ImportUpload.vue';
import FileServeUpload from './FileServeUpload/FileServeUpload.vue';
import FileUploadList from './FileServeUpload/FileUploadList.vue';
import FileList from './FileServeUpload/FileList.vue';
import ImageUpload from './FileServeUpload/ImageUpload.vue';
import ImageUploadList from './FileServeUpload/ImageUploadList';
import ImagePreview from './FileServeUpload/ImagePreview.vue';
import SelectAddress from './SelectAddress/index.vue';
import SelectSb from './SelectSb/index.vue';
import SelectXmUser from './SelectXmUser/SelectXmUser.vue';
import TextareaRead from './TextareaRead/TextareaRead.vue';
import KButton from './KButton/KButton.vue';
import ImagePreviewDialog from './common-image/ImagePreviewDialog.vue';
import ImageUploader from './common-image/ImageUploader.vue';
import ImageThumbViewer from './common-image/ImageThumbViewer.vue';
import DictSelect from './dict/DictSelect.vue';
import DictTag from './dict/DictTag.vue';

Vue.use(ChartComponents);
Vue.component('ReProgress', ReProgress);
Vue.component('ViewImgDialog', ViewImgDialog);
Vue.component('ViewVideoDialog', ViewVideoDialog);
Vue.component('DeptTree', DeptTree);
Vue.component('SyncDeptTree', SyncDeptTree);
Vue.component('AsyncDeptTree', AsyncDeptTree);
Vue.component('KTable', KTable);
Vue.component('KTableInfinite', KTableInfinite);
Vue.component('ImportUpload', ImportUpload);
Vue.component('FileServeUpload', FileServeUpload);
Vue.component('FileUploadList', FileUploadList);
Vue.component('FileList', FileList);
Vue.component('ImageUpload', ImageUpload);
Vue.component('ImageUploadList', ImageUploadList);
Vue.component('ImagePreview', ImagePreview);
Vue.component('SelectAddress', SelectAddress);
Vue.component('SelectSb', SelectSb);
Vue.component('SelectXmUser', SelectXmUser);
Vue.component('TextareaRead', TextareaRead);
Vue.component('KButton', KButton);
Vue.component('ImagePreviewDialog', ImagePreviewDialog);
Vue.component('ImageUploader', ImageUploader);
Vue.component('ImageThumbViewer', ImageThumbViewer);
Vue.component('DictSelect', DictSelect);
Vue.component('DictTag', DictTag);
